export const SEETAI = {
  brand: {
    name: "Seetai Properties",
    legalName: "Seetai Properties Private Limited",
    tagline: "Crafting Luxury. Building Legacy.",
    monogram: "S",
  },
  contact: {
    whatsapp: "+91 96372 41414",
    whatsappDigits: "919637241414",
    website: "www.seetaiproperties.com",
    headquarters: "Pune & Pandharpur, Maharashtra, India",
    siteAddress: "Airport Link Road, Bhandgaon Jejuri Road, Khor, Maharashtra 412214",
    email: "info@seetaiproperties.com",
  },
  social: {
    instagram: "#",
    facebook: "#",
    linkedin: "#",
    youtube: "#",
  },
  projectInterests: [
    "Silva City",
    "Commercial Spaces",
    "Premium NA Plotting",
    "Other",
  ],
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Our Projects", to: "/projects" },
  { label: "Services", to: "/services" },
  { label: "Contact Us", to: "/contact" },
];
